<template>
    <Fragment>
        <!-- catalog_complect -->
        <div class="row catalog_complect mt_sm">
            <div class="col-12">
                <div class="catalog_complect_body">
                    <div class="info_title catalog_complect_title">
                        Данное изделие является частью комплекта. <b>Полный комплект</b> состоит из нескольких
                        частей, напр. (А), (B), (С) и (D). <a href="/complects">Справка о комплектах</a>
                    </div>
                    <div class="row">
                        <div class="col-12 col-lg-3">
                            <div class="cc_p item_icon mt_md">
                                <div v-for="(item, index) in items">
                                    <template v-if="item">
                                        <img v-if="index == 'A'" src="/i/a.svg" alt="Часть A">
                                        <img v-if="index == 'B'" src="/i/b.svg" alt="Часть B">
                                        <img v-if="index == 'C'" src="/i/c.svg" alt="Часть C">
                                        <img v-if="index == 'D'" src="/i/d.svg" alt="Часть D">
                                        
                                        <div class="item_picture">
                                            <div v-if="item.images && item.images[0]" :style="'background-image: url(/storage/' + item.images[0].path + ')'"></div>
                                            <div v-else></div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-lg-9">
                            <ul class="cc_price item_price list-group list-group-horizontal-md">
                                <li class="list-group-item mt_xs">
                                    <div class="price_lg">{{ price }} р. за комплект</div>
                                    <div class="small_info">В наборе по <span
                                            class="accent">{{ item.qty_per_pack }} {{ item.unit }}</span>
                                        каждой части</div>
                                </li>
                                <li class="list-group-item mt_xs">
                                    <div class="price_lg">
                                        {{ priceForPack }} 
                                        р. за набор</div>
                                    <div class="small_info">По сумме заказа – <a href="/discounts">скидки</a></div>
                                </li>
                            </ul>
                            <div class="cc_action form-inline clearfix">
                                <cart-add-big-button
                                    :id="itemsIds"
                                    :qty_per_pack="item.qty_per_pack" 
                                    :qty_in_stock="qtyInStock"
                                    :set_id="setId">
                                </cart-add-big-button>

                            </div>
                            
                            <!-- <div class="cc_added item_added mt_xxs d-none">В корзине <span>100 ед.</span> (1
                                упаковка) на <span>445.00 р.</span> <a href="#">Удалить</a></div> -->
                            
                        </div>

                    </div>
                </div>

            </div>
        </div>
        <!-- //catalog_complect -->
    </Fragment>
</template>


<script>
import { Fragment } from "vue-fragment";

export default {
    props: ['id', 'part', 'item', 'qty-per-pack', 'unit', 'set'],

    components: { Fragment },

    data: function () {
        return {
            color: [],
            size: [],
        };
    },

    methods: {
    },
    computed: {
        items() {
            console.log(this.$store.state.set.items);
           
            return this.$store.state.set.items;
        },
        setId() {
            return this.set.id + ':' + this.itemsIds;
        },
        price() {  
            let price = 0;
                      
            let prices = Object.keys(this.$store.state.set.items).map((key, index) => {
                if (this.$store.state.set.items[key]  !== null) {
                    console.log(this.$store.state.set.items[key]);
                    return parseFloat(this.$store.state.set.items[key].price);
                }

                return null;
            });

            for (let i = 0; i < prices.length; i++) {
                price += prices[i];
            }

            return price.toFixed(2);
        },
        priceForPack() {  
            let price = this.price * this.item.qty_per_pack;

            return price.toFixed(2);
        },
        qtyInStock() {  
            let qty = parseInt(this.item.qty_in_stock);
                      
            let qtys = Object.keys(this.$store.state.set.items).map((key, index) => {
                if (this.$store.state.set.items[key]  !== null) {
                    return parseInt(this.$store.state.set.items[key].qty_in_stock);
                }

                return null;
            }).filter((item, index) => {
                return item !== null;
            });

            for (let i = 0; i < qtys.length; i++) {
                if (qtys[i] < qty) {
                    qty = qtys[i];
                }
            }

            return qty;
        },
        itemsIds() {
            let ids = Object.keys(this.$store.state.set.items).map((key, index) => {
                if (this.$store.state.set.items[key]  !== null) {
                    return this.$store.state.set.items[key].id;
                }

                return null;
            }).filter((item, index) => {
                return item !== null;
            });

            return ids.join(',');
        },
    },
    mounted() {        
        let params = {
            A: this.item
        }

        this.$store.dispatch("set/setItem", params);
    }
};
</script>
